import { render, staticRenderFns } from "./admin-add-edit.vue?vue&type=template&id=5c989ed4&scoped=true&"
import script from "./admin-add-edit.vue?vue&type=script&lang=js&"
export * from "./admin-add-edit.vue?vue&type=script&lang=js&"
import style0 from "./admin-add-edit.vue?vue&type=style&index=0&id=5c989ed4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c989ed4",
  null
  
)

export default component.exports